import { nextTick, ref } from "vue";
import { scrollToFirstFormError } from "@/shared/forms/utils/scrollToFirstFormError";

export const useFormErrorScroll = () => {
  const formRef = ref<HTMLElement | null>(null);

  const scrollToFirstError = async () => {
    await nextTick();
    scrollToFirstFormError(formRef.value);
  };

  return { formRef, scrollToFirstError };
};
